import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isfetching: false,
  toolData: null,
  isSuccess: false,
  message: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionConstants.ADD_TOOL_SUCCESS:
      return {
        ...state,
        toolData: action.payload,
        message: action.message,
        isfetching: false,
        isSuccess: true,
      };
    case actionConstants.ADD_TOOL_REQUEST:
      return {
        ...state,
        isfetching: true,
      };
    case actionConstants.ADD_TOOL_FAILURE:
      return {
        ...state,
        isfetching: false,
        error: action.message,
        isSuccess: false,
      };
    case actionConstants.ADD_TOOL_RESET:
      return { ...initialState };
    default:
      return state;
  }
};
